export type ToastVariant = "success" | "warning" | "error";

export type ToastOptions = {
	variant?: ToastVariant;
	text: string;
	persist?: boolean;
};

export function toast(options: ToastOptions): void {
	window.dispatchEvent(
		new CustomEvent("gg:toast", {
			detail: {
				variant: options.variant ?? "success",
				text: options.text,
				persist: options.persist === true,
			},
		}),
	);
}

// HTTP status from a sb.functions.invoke error. Used to distinguish soft
// conflicts (409) from hard errors so the right toast variant fires.
export function getErrorStatus(error: unknown): number | undefined {
	if (!error || typeof error !== "object") return undefined;
	const ctx = (error as { context?: { status?: number } }).context;
	return ctx?.status;
}
